export enum PromotionTypes {
  Product = 'product',
  Experience = 'experience',
  Deposit = 'deposit',
  Discount = 'discount',
  Event = 'event',
  LateCancellation = 'late_cancellation',
  PayOnline = 'pay-online',
}
